import { render, staticRenderFns } from "./FinancesExpenceForm.vue?vue&type=template&id=0a361fa4&scoped=true"
import script from "./FinancesExpenceForm.vue?vue&type=script&lang=js"
export * from "./FinancesExpenceForm.vue?vue&type=script&lang=js"
import style0 from "./FinancesExpenceForm.vue?vue&type=style&index=0&id=0a361fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a361fa4",
  null
  
)

export default component.exports